import { jsPDF } from 'jspdf';

const formatDisplayDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
};

export const downloadVendorInvoicePdf = (invoice) => {
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });
  const pageWidth = doc.internal.pageSize.getWidth();

  doc.setFillColor(245, 240, 235);
  doc.rect(0, 0, pageWidth, 842, 'F');

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(22);
  doc.text('MAZ PHOTOGRAPHY', pageWidth / 2, 52, { align: 'center' });
  doc.setFontSize(16);
  doc.text('Gibraltar Wedding Expo Online', pageWidth / 2, 76, { align: 'center' });

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.text(`Email: ${invoice.issuer.email}`, pageWidth / 2, 98, { align: 'center' });
  doc.text(`Tel: ${invoice.issuer.phone}`, pageWidth / 2, 113, { align: 'center' });

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(13);
  doc.text(formatDisplayDate(invoice.invoice_date), 48, 160);
  doc.text(`Invoice ${invoice.invoice_number}`, 390, 160);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(12);
  doc.text(`Dear ${invoice.invoice_to}`, 48, 205);
  doc.text(`Invoice to: ${invoice.invoice_to}`, 48, 228);

  doc.setDrawColor(210, 197, 184);
  doc.line(48, 252, 545, 252);
  doc.setFont('helvetica', 'bold');
  doc.text('Item Description', 48, 274);
  doc.text('Quantity', 330, 274);
  doc.text('Price', 410, 274);
  doc.text('Total', 490, 274);
  doc.line(48, 284, 545, 284);

  doc.setFont('helvetica', 'normal');
  doc.text(invoice.line_description, 48, 308);
  doc.text('1', 350, 308);
  doc.text(`£${invoice.amount}`, 410, 308);
  doc.text(`£${invoice.amount}`, 490, 308);
  doc.text(`Ref ${invoice.reference_code}`, 48, 330);

  doc.setFont('helvetica', 'bold');
  doc.text('Payment Method', 48, 382);
  doc.setFont('helvetica', 'normal');
  doc.text(invoice.payment_method || 'We will contact you', 48, 402);

  const paymentMethod = invoice.payment_method || '';

  if (paymentMethod === 'Card' || paymentMethod === 'By Card') {
    doc.text('We will contact you to arrange card payment.', 48, 425);
  } else if (paymentMethod === 'Revolut' || paymentMethod === 'By Revolut') {
    doc.text(`Revolut: ${invoice.issuer.revolut_phone || '+350 56690000'} or ${invoice.issuer.revolut_handle || '@mariangib'}`, 48, 425);
  } else if (paymentMethod === 'Bank Transfer') {
    doc.setFont('helvetica', 'bold');
    doc.text('Business Account', 48, 425);
    doc.setFont('helvetica', 'normal');
    doc.text(`Account name: ${invoice.issuer.account_name || 'MRS MARIAN ALAMI-MERCER'}`, 48, 446);
    doc.text(`Bank: ${invoice.issuer.bank || 'Natwest Gibraltar'}`, 48, 465);
    doc.text(`Sort Code: ${invoice.issuer.sort_code || '60-60-60'}`, 48, 484);
    doc.text(`Account Number: ${invoice.issuer.account_number || '48271306'}`, 48, 503);
    doc.text(`BIC: ${invoice.issuer.bic || 'RBOSGIGI'}`, 48, 522);
    doc.text(`IBAN: ${invoice.issuer.iban || 'GI08NWBK060606048271306'}`, 48, 541);
  } else {
    doc.text('Contact admin for payment details.', 48, 425);
  }

  doc.text('Kind Regards', 48, 620);
  doc.text(invoice.issuer.sign_off, 48, 640);
  doc.text('MAZ Photography', 48, 660);
  doc.text(invoice.issuer.website, 48, 680);

  doc.save(`${invoice.invoice_number}.pdf`);
};